module.exports = __webpack_public_path__ + "img/indirect-service.d0e6f582.svg";